(function () {
    'use strict';
    var controllerId = 'error';
    angular.module('app').controller(controllerId, ['$state', error]);

    function error($state) {
        var scope = this;

        scope.getErrorReason = function ($scope) {
            var errorReason = $state.params.errorReason;
            scope.errorReason = errorReason;
        }

        this.getErrorReason();
    }

})();